import React, { useEffect, useState } from "react";
import Menu from "../componets/Menu";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useWindowSize } from "../componets/useWindowSize";
import {
  getButtonCollapsedMemory,
  getMenuCollapsedMemory,
  getVersionApp,
  setButtonCollapsedmemory,
  setMenuCollapsedmemory,
} from "../data/memory";
import { autoResetJogosMensal } from "../data/autoClear";
import { resetList } from "../data/resetList";
import { getAuth } from "firebase/auth";
import { getDatabase, onValue, ref, update } from "firebase/database";
import AlertSuccess from "../componets/AlerSuccess";
import AlertError from "../componets/AlertError";
import { useNavigate } from "react-router-dom";

const Bloqueio: React.FC = () => {
  const { width } = useWindowSize();
  const auth = getAuth();
  const navigate = useNavigate();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  );
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );
  const [requestStatus, setRequestStatus] = useState<"none" | "pending">(
    "none"
  );
  const [loading, setLoading] = useState(false);
  const [successAlert, setSuccessAlert] = useState({
    open: false,
    message: "",
  });
  const [errorAlert, setErrorAlert] = useState({ open: false, message: "" });

  useEffect(() => {
    resetList();
    autoResetJogosMensal();
  }, []);

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else if (!getButtonCollapsedMemory()) {
      setIsMenuCollapsed(false);
      setMenuCollapsedmemory(false);
    }
  }, [width]);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const userRef = ref(getDatabase(), `users/${user.uid}`);
    return onValue(userRef, (snapshot) => {
      const data = snapshot.val() || {};

      if (data.bloq !== true) {
        navigate("/lista");
        return;
      }

      setRequestStatus(
        data.solicitacaoReentrada === "pending" ? "pending" : "none"
      );
    });
  }, [auth, navigate]);

  const handleMenuToggle = () => {
    const newButtonCollapsed = !isButtonCollapsed;
    const newMenuCollapsed = !isMenuCollapsed;
    setIsButtonCollapsed(newButtonCollapsed);
    setButtonCollapsedmemory(newButtonCollapsed);
    setIsMenuCollapsed(newMenuCollapsed);
    setMenuCollapsedmemory(newMenuCollapsed);
  };

  const handleRequestAccess = async () => {
    const user = auth.currentUser;
    if (!user) {
      setErrorAlert({
        open: true,
        message: "Não foi possível identificar a usuária logada.",
      });
      return;
    }

    try {
      setLoading(true);
      await update(ref(getDatabase(), `users/${user.uid}`), {
        solicitacaoReentrada: "pending",
      });
      setRequestStatus("pending");
      setSuccessAlert({
        open: true,
        message: "Solicitação enviada. Agora é só aguardar a aprovação.",
      });
    } catch (error) {
      console.error(error);
      setErrorAlert({
        open: true,
        message: "Erro ao enviar solicitação.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex h-dvh bg-black">
      <AlertSuccess
        isOpen={successAlert.open}
        message={successAlert.message}
        onClose={() => setSuccessAlert({ open: false, message: "" })}
      />
      <AlertError
        isOpen={errorAlert.open}
        message={errorAlert.message}
        onClose={() => setErrorAlert({ open: false, message: "" })}
      />

      <div
        className={`fixed top-0 left-0 flex h-full flex-col ${
          isMenuCollapsed ? "w-16" : "w-64"
        } bg-black text-white transition-all duration-300`}
      >
        <button className="p-4 text-white" onClick={handleMenuToggle}>
          {isMenuCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        <div className="min-h-0 flex-1">
          <Menu isCollapsed={isMenuCollapsed} />
        </div>
      </div>

      <section
        className={`flex-1 bg-black p-4 pt-4 sm:p-6 ${
          isMenuCollapsed ? "ml-16" : "ml-64"
        } transition-all duration-300`}
      >
        <div className="mx-auto mt-12 flex max-w-xl flex-col gap-6 rounded-2xl bg-gray-900 p-6 text-white shadow-lg sm:p-8">
          <h2 className="text-center text-xl font-semibold sm:text-2xl">
            Acesso pausado no momento
          </h2>
          <p className="text-center text-sm leading-relaxed text-zinc-300 sm:text-base">
            Seu acesso ao grupo foi encerrado e seus dados operacionais foram
            limpos do sistema. Se quiser voltar a participar, você pode enviar
            uma solicitação para nova aprovação.
          </p>

          <button
            onClick={handleRequestAccess}
            disabled={loading || requestStatus === "pending"}
            className={`rounded-xl px-4 py-3 font-semibold text-white transition ${
              requestStatus === "pending"
                ? "cursor-not-allowed bg-zinc-700"
                : "bg-pink-600 hover:bg-pink-500"
            }`}
          >
            {requestStatus === "pending"
              ? "Aguardando aprovação"
              : loading
              ? "Enviando..."
              : "Solicitar permissão para entrar no grupo novamente"}
          </button>
        </div>

        <div className="w-full py-6 text-center">
          <span className="text-xs text-zinc-500 sm:text-sm">
            Developed by Samuel Stork
          </span>{" "}
          <span className="text-xs text-zinc-600 sm:text-sm">
            {getVersionApp()}
          </span>
        </div>
      </section>
    </main>
  );
};

export default Bloqueio;
